<template>
  <div class="table-responsive my-3">
    <table class="table table-bordered align-middle">
      <caption class="caption-top text-start px-0">
        桂运宝两类运力的分工。表内只说明自有车辆和社会运力，不与其他公司比较。
      </caption>
      <thead>
        <tr>
          <th scope="col">运力类型</th>
          <th scope="col">作用</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in rows" :key="row.type">
          <th scope="row">{{ row.type }}</th>
          <td>{{ row.role }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { CAPACITY_ROWS } from "@/seo/site";

/**
 * 新能源重卡与社会运力对照表。
 */
export default {
  name: "CapacityTable",
  data: function () {
    return {
      rows: CAPACITY_ROWS,
    };
  },
};
</script>
